module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medicalNews"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("基础信息")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "病例名称:",
      "prop": "caseName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "50",
      "placeholder": "请输入病例名称"
    },
    model: {
      value: (_vm.detail.caseName),
      callback: function($$v) {
        _vm.$set(_vm.detail, "caseName", $$v)
      },
      expression: "detail.caseName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "性别:",
      "prop": "caseSex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.detail.caseSex),
      callback: function($$v) {
        _vm.$set(_vm.detail, "caseSex", $$v)
      },
      expression: "detail.caseSex"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "age",
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "年龄:",
      "prop": "caseAge"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    staticClass: "inputAge",
    attrs: {
      "placeholder": "请输入年龄"
    },
    model: {
      value: (_vm.detail.caseAge),
      callback: function($$v) {
        _vm.$set(_vm.detail, "caseAge", $$v)
      },
      expression: "detail.caseAge"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticClass: "garal"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "inputAgeUnit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.detail.ageUnit),
      callback: function($$v) {
        _vm.$set(_vm.detail, "ageUnit", $$v)
      },
      expression: "detail.ageUnit"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "备注:"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注",
      "maxlength": "340",
      "type": "textarea"
    },
    model: {
      value: (_vm.detail.remark),
      callback: function($$v) {
        _vm.$set(_vm.detail, "remark", $$v)
      },
      expression: "detail.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("就诊信息")])]), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "病史:"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入病史",
      "maxlength": "340",
      "type": "textarea"
    },
    model: {
      value: (_vm.detail.history),
      callback: function($$v) {
        _vm.$set(_vm.detail, "history", $$v)
      },
      expression: "detail.history"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "病理结果:"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入病理结果",
      "maxlength": "1300",
      "type": "textarea"
    },
    model: {
      value: (_vm.detail.caseResult),
      callback: function($$v) {
        _vm.$set(_vm.detail, "caseResult", $$v)
      },
      expression: "detail.caseResult"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "检查所见:"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入检查所见",
      "maxlength": "1300",
      "type": "textarea"
    },
    model: {
      value: (_vm.detail.evidence),
      callback: function($$v) {
        _vm.$set(_vm.detail, "evidence", $$v)
      },
      expression: "detail.evidence"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "诊断结果:"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入诊断结果",
      "type": "textarea"
    },
    model: {
      value: (_vm.detail.dianogeResult),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dianogeResult", $$v)
      },
      expression: "detail.dianogeResult"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-388f5294","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/medicalNews/medicalNews.vue
// module id = 554
// module chunks = 1 2 3 4 5 6 7 8